import React, { useRef } from "react";
import MovieCard from "./MovieCard/MovieCard";
import SkeletonCard from "./SkeletonCard/SkeletonCard";

const MovieList = ({ movies, loading }) => {
  const containerRef = useRef(null);
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        ref={containerRef}
        style={{
          display: "flex",
          overflowX: "auto",
          scrollBehavior: "smooth",
          width: "100%",
          scrollbarWidth: "none",
          msOverflowStyle: "none", 
          WebkitOverflowScrolling: "touch", 
        }}
      >
        <style>
          {`
            div::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>
        {loading
          ? Array(10)
              .fill(null)
              .map((_, index) => (
                <div
                  key={index}
                  style={{
                    marginRight: "20px",
                    userSelect: "none",
                    flexShrink: 0,
                  }}
                >
                  <SkeletonCard />
                </div>
              ))
          : movies.map((movie) => (
              <div
                key={movie._id}
                style={{
                  marginRight: "20px",
                  userSelect: "none",
                  flexShrink: 0,
                }}
              >
                <MovieCard movie={movie} />
              </div>
            ))}
      </div>
    </div>
  );
};

export default MovieList;
